(function () {
  var root = document.getElementById('selah-tryon-ai');
  if (!root) return;
  var WORKER_URL = "https://broad-snow-7354.askewsixten07.workers.dev";
  var GEMINI_KEY = "";
  var POLLINATIONS_KEY = "";
  var NECKLACE_URL = "https://cdn.shopify.com/s/files/1/0665/6802/8221/files/media-generation-selah-product-clean-0-029a1716-1e41-43db-9954-9b9fcf3a1ca2.jpg?v=1792350230";
  var head = document.getElementById('selah-tryon-ai-head');
  var openBtn = document.getElementById('selah-tryon-open');
  var fileInput = document.getElementById('selah-tryon-ai-file');
  var uploadBox = document.getElementById('selah-tryon-ai-upload');
  var stage = document.getElementById('selah-tryon-ai-stage');
  var retryBtn = document.getElementById('selah-tryon-ai-retry');
  var resultCloseBtn = document.getElementById('selah-tryon-ai-result-close');
  var preview = document.getElementById('selah-tryon-ai-preview');
  var statusEl = document.getElementById('selah-tryon-ai-status');
  var generateBtn = document.getElementById('selah-tryon-ai-generate');
  var resultBox = document.getElementById('selah-tryon-ai-result');
  var outputImg = document.getElementById('selah-tryon-ai-output');
  var selfieDataUrl = null;

  function downscale(dataUrl, maxSide, done) {
    var im = new Image();
    im.onload = function () {
      var ratio = Math.min(1, maxSide / Math.max(im.width, im.height));
      var c = document.createElement('canvas');
      c.width = Math.round(im.width * ratio);
      c.height = Math.round(im.height * ratio);
      c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
      done(c.toDataURL('image/jpeg', 0.88));
    };
    im.onerror = function () { done(null); };
    im.src = dataUrl;
  }

  function splitDataUrl(dataUrl) {
    var m = /^data:(image\/[a-z]+);base64,(.*)$/.exec(dataUrl || '');
    if (!m) return null;
    return { mimeType: m[1], data: m[2] };
  }

  function fetchAsBase64(url) {
    return fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('necklace fetch failed');
      return r.blob();
    }).then(function (blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve(splitDataUrl(reader.result)); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
  }

  function uploadSelfieToCatbox(dataUrl) {
    return fetch(dataUrl).then(function (r) { return r.blob(); }).then(function (blob) {
      var fd = new FormData();
      fd.append('reqtype', 'fileupload');
      fd.append('fileToUpload', blob, 'selfie.jpg');
      return fetch('https://catbox.moe/user/api.php', { method: 'POST', body: fd });
    }).then(function (r) {
      if (!r.ok) throw new Error('upload failed');
      return r.text();
    }).then(function (t) {
      t = (t || '').trim();
      if (t.indexOf('http') !== 0) throw new Error('bad upload response');
      return t;
    });
  }

  function pollinationsGenerate() {
    var prompt = 'Put a delicate 925 sterling silver cross pendant necklace on the woman. The pendant is a small cross with exactly six small round sparkling stones: one stone at the top, three stones across the horizontal bar, and two stones below the bar. Keep her face, hair, clothing and background exactly the same. Photorealistic.';
    return uploadSelfieToCatbox(selfieDataUrl).then(function (catUrl) {
      var url = 'https://gen.pollinations.ai/image/' + encodeURIComponent(prompt) +
        '?model=kontext&image=' + encodeURIComponent(catUrl) + '&nologo=true';
      return fetch(url, { headers: { 'Authorization': 'Bearer ' + POLLINATIONS_KEY } });
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          var msg = 'The AI service could not generate a preview right now.';
          try {
            var j = JSON.parse(t);
            if (j.error && j.error.message) msg = j.error.message;
          } catch (e) {}
          if (r.status === 402 || r.status === 429) msg = 'The try-on has reached its limit for now. Please try again later.';
          return { ok: false, body: { error: msg } };
        });
      }
      return r.blob().then(function (blob) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = function () { resolve({ ok: true, body: { image: reader.result } }); };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    }).catch(function () {
      return { ok: false, body: { error: 'Could not reach the AI service. Please try again.' } };
    });
  }

  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (!f) return;
    var reader = new FileReader();
    reader.onload = function () {
      downscale(reader.result, 1024, function (small) {
        // If the browser cannot decode the photo for downscaling (some phone
        // photos), fall back to the original file instead of a blank tile:
        // the preview may still display natively, and generating still works
        // because the service decodes the original server-side.
        selfieDataUrl = small || reader.result;
        preview.src = selfieDataUrl;
        resultBox.hidden = true;
        statusEl.textContent = '';
        head.hidden = true;
        uploadBox.hidden = true;
        openBtn.hidden = true;
        stage.hidden = false;
        // Bring the try-on slide back into view: closing the photo picker
        // can scroll the gallery away from it (Safari restores the slider's
        // scroll position after dismissal), which reads as the tile vanishing.
        // Re-assert after dismissal, since a restore can land after this
        // handler runs. Delta-based, so it works regardless of which
        // ancestor the browser treats as the offset parent.
        function scrollTryonIntoView() {
          if (stage.hidden) return;
          var slide = root.closest ? root.closest('.product__media-item') : null;
          var slider = slide && slide.parentElement;
          if (!slide || !slider || !slider.scrollTo) return;
          var sliderRect = slider.getBoundingClientRect();
          var slideRect = slide.getBoundingClientRect();
          slider.scrollTo({ left: slider.scrollLeft + (slideRect.left - sliderRect.left) });
        }
        // Phone-proof guard: iOS Safari can restore the slider's scroll
        // position after the photo picker closes, at unpredictable timing,
        // which reads as the tile vanishing. Keep re-asserting the slide
        // into view for a few seconds after upload; stop the moment the
        // shopper touches the gallery themselves, so it never fights them.
        scrollTryonIntoView();
        (function () {
          var guardUntil = Date.now() + 3000;
          var slide = root.closest ? root.closest('.product__media-item') : null;
          var slider = slide && slide.parentElement;
          if (slider) {
            slider.addEventListener('touchstart', function () { guardUntil = 0; }, { passive: true, once: true });
          }
          (function guard() {
            if (stage.hidden || Date.now() > guardUntil) return;
            scrollTryonIntoView();
            setTimeout(guard, 250);
          })();
        })();
      });
    };
    reader.readAsDataURL(f);
  });

  function generate() {
    if (!selfieDataUrl) return;
    if (!WORKER_URL && !POLLINATIONS_KEY && !GEMINI_KEY) {
      statusEl.textContent = 'AI try-on is not connected yet — the store is still setting it up. Please check back soon.';
      return;
    }
    generateBtn.disabled = true;
    retryBtn.disabled = true;
    resultBox.hidden = true;
    statusEl.textContent = 'AI is placing the necklace on your photo… this takes about 20 seconds.';
    var necklacePromise = (NECKLACE_URL && !POLLINATIONS_KEY)
      ? fetchAsBase64(NECKLACE_URL).catch(function () { return null; })
      : Promise.resolve(null);
    necklacePromise.then(function (necklace) {
      if (WORKER_URL) {
        var payload = { selfie: splitDataUrl(selfieDataUrl) };
        if (necklace) payload.necklace = necklace;
        // Pre-downscaled (<512px) copies for the Worker's reliable-engine
        // fallback, used automatically when the primary engine hits its limit.
        var smallPromise = new Promise(function (resolve) {
          downscale(selfieDataUrl, 480, function (smallSelfie) {
            if (!smallSelfie) { resolve({}); return; }
            var small = { selfieSmall: splitDataUrl(smallSelfie) };
            if (necklace) {
              downscale('data:' + necklace.mimeType + ';base64,' + necklace.data, 480, function (smallNeck) {
                if (smallNeck) small.necklaceSmall = splitDataUrl(smallNeck);
                resolve(small);
              });
            } else {
              resolve(small);
            }
          });
        }).catch(function () { return {}; });
        return smallPromise.then(function (small) {
          if (small.selfieSmall) payload.selfieSmall = small.selfieSmall;
          if (small.necklaceSmall) payload.necklaceSmall = small.necklaceSmall;
          return fetch(WORKER_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
        });
      }
      if (POLLINATIONS_KEY) {
        return pollinationsGenerate();
      }
      var promptWithRef = 'Edit the first image so the person in it is wearing the necklace shown in the second image. The necklace must stay exactly as shown: a sterling silver cross pendant with exactly six round moissanite stones — one on top, three across, two below — on a fine silver chain, draped naturally around the neck with realistic lighting, shadows, and contact with skin. Do not change the person\'s face, hair, clothing, or the background. Do not add any text, watermark, or logo.';
      var promptNoRef = 'Edit the image so the person in it is wearing a sterling silver cross pendant necklace with exactly six round moissanite stones — one on top, three across, two below — on a fine silver chain, draped naturally around the neck with realistic lighting, shadows, and contact with skin. Do not change the person\'s face, hair, clothing, or the background. Do not add any text, watermark, or logo.';
      var parts = [{ text: necklace ? promptWithRef : promptNoRef }, { inlineData: splitDataUrl(selfieDataUrl) }];
      if (necklace) parts.push({ inlineData: necklace });
      return fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-image:generateContent', {
        method: 'POST',
        headers: { 'x-goog-api-key': GEMINI_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contents: [{ parts: parts }],
          generationConfig: { responseModalities: ['TEXT', 'IMAGE'] },
        }),
      }).then(function (r) { return r.json().then(function (j) {
        var outPart = ((j.candidates || [])[0] || {}).content;
        outPart = outPart && outPart.parts ? outPart.parts : [];
        var found = null;
        for (var i = 0; i < outPart.length; i++) {
          var d = outPart[i].inlineData || outPart[i].inline_data;
          if (d && d.data) { found = d; break; }
        }
        if (!r.ok) return { ok: false, body: { error: (j.error && j.error.message) || 'The AI service could not generate a preview right now.' } };
        if (!found) return { ok: false, body: { error: 'The AI service returned no image. Please try again.' } };
        return { ok: true, body: { image: 'data:' + (found.mimeType || found.mime_type || 'image/png') + ';base64,' + found.data } };
      }); });
    }).then(function (res) {
      generateBtn.disabled = false;
      retryBtn.disabled = false;
      if (!res.ok || !res.body.image) {
        statusEl.textContent = (res.body && res.body.error) || 'Something went wrong. Please try again.';
        return;
      }
      outputImg.src = res.body.image;
      stage.hidden = true;
      resultBox.hidden = false;
      statusEl.textContent = 'Here you are — wearing the Selah Cross Necklace.';
    }).catch(function () {
      generateBtn.disabled = false;
      retryBtn.disabled = false;
      statusEl.textContent = 'Could not reach the AI service. Please try again.';
    });
  }

  // If even the original photo cannot be previewed in this browser, say so
  // plainly instead of leaving a blank tile — generating can still work.
  preview.onerror = function () {
    statusEl.textContent = 'This photo could not be previewed here, but you can still tap Generate to try it.';
  };

  generateBtn.addEventListener('click', generate);
  retryBtn.addEventListener('click', function () {
    stage.hidden = false;
    resultBox.hidden = true;
    generate();
  });

  function resetToIdle() {
    fileInput.value = '';
    selfieDataUrl = null;
    stage.hidden = true;
    resultBox.hidden = true;
    statusEl.textContent = '';
    head.hidden = false;
    uploadBox.hidden = false;
    openBtn.hidden = false;
  }
  document.getElementById('selah-tryon-ai-again').addEventListener('click', resetToIdle);
  resultCloseBtn.addEventListener('click', resetToIdle);

  document.getElementById('selah-tryon-ai-download').addEventListener('click', function () {
    if (!outputImg.src) return;
    var a = document.createElement('a');
    a.href = outputImg.src;
    a.download = 'selah-cross-necklace-tryon.png';
    a.click();
  });

  // On phones the tile's button opens the photo picker directly; everything
  // then happens inside the tile.
  if (openBtn) openBtn.addEventListener('click', function () { fileInput.click(); });
})();
